import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestHeaders } from "src/app/shared/general/constants";
import { FlowService } from "../services/flow.service";
import { parseRequestBody } from "../utils/object";

@Injectable()
export class ParamsInterceptor implements HttpInterceptor {
  constructor(private flowService: FlowService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    request = this.appendFlowToken(request);
    return next.handle(request);
  }

  private appendFlowToken(request: HttpRequest<any>) {
    let flowToken = null;

    /*
        This condition set flow_token in header from flow service for
        endpoints contains ‘flow' or 'token’ in GET request URL as we are
        sending flow_tokens in flow requests only.
    */
    if (
      this.flowService.getFlowAccessToken() &&
      (request.url.indexOf("flow") !== -1 ||
        request.url.indexOf("token") !== -1)
    ) {
      flowToken = this.flowService.getFlowAccessToken();
    }

    const jsonBody = parseRequestBody(request.body);
    if (jsonBody?.["flow_token"]) {
      flowToken = jsonBody?.["flowToken"];
    }
    if (flowToken && typeof flowToken === "string") {
      return request.clone({
        headers: request.headers.append(RequestHeaders.X_FLOW_TOKEN, flowToken),
      });
    }
    return request;
  }
}
